import i18next from "i18next";
import { phoneMask } from "../../../config";
import { Description, FormBlock, Header, InputBlock, Title, Wrapper } from "./style";
import { InputComponent } from "../../ui";

const BookingPayerInfoComponent = ({ form }) => {
  const { t } = i18next;

  const { values, errors, touched, handleBlur, setFieldValue } = form;

  const handleChangeEmail = value => {
    setFieldValue("payer_email", value);
    setFieldValue("passengers[0].email", value);
  };

  const handleChangePhone = value => {
    setFieldValue("payer_phone", value);
    setFieldValue("passengers[0].phone", value);
  };

  // Handle Enter key press to move to next field
  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      
      // Find the next input field
      const form = e.target.form;
      if (form) {
        const inputs = Array.from(form.elements).filter(
          el => (el.tagName === 'INPUT' || el.tagName === 'TEXTAREA' || el.tagName === 'SELECT') && !el.disabled && el.type !== 'hidden' && el.type !== 'button' && el.type !== 'submit'
        );
        const currentIndex = inputs.indexOf(e.target);
        const nextInput = inputs[currentIndex + 1];
        
        if (nextInput) {
          nextInput.focus();
        } else {
          // At the last field, blur to hide mobile keyboard
          e.target.blur();
        }
      }
    }
  };

  return (
    <Wrapper>
      <Header>
        <Title>{t("payer_contacts")}</Title>
        <Description>
          <span>{t("for_payer_mess")}.</span>
        </Description>
      </Header>


      <FormBlock className="two-col">
        <InputBlock>
          <InputComponent
            value={values.payer_email}
            touched={touched.payer_email}
            error={touched.payer_email && errors.payer_email}
            success={touched.payer_email && !errors.payer_email && values.payer_email}
            onChange={handleChangeEmail}
            onBlur={handleBlur("payer_email")}
            onKeyDown={handleKeyDown}
            placeholder={t("email")}
            label={t("email")}
            required
          />
        </InputBlock>

        <InputBlock>
          <InputComponent
            value={values.payer_phone}
            touched={touched.payer_phone}
            error={touched.payer_phone && errors.payer_phone}
            onChange={handleChangePhone}
            onBlur={handleBlur("payer_phone")}
            onKeyDown={handleKeyDown}
            placeholder={t("phone_number")}
            label={t("phone_number")}
            mask={phoneMask}
            guide={false}
            required
          />
        </InputBlock>
      </FormBlock>
    </Wrapper>
  );
};

export default BookingPayerInfoComponent;
